// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.api.web.handler.TourSchedulingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RescheduleTourByIreneWebApiRequestDto, TourWebApiDto } from '../..';

export const TourSchedulingWebApiHandler_rescheduleTourByIrene_Path =
  '/api/web/v1/touring/scheduling/rescheduleTourByIrene';

/**
 * reschedule a tour (initiated by Irene)
 */
export const TourSchedulingWebApiHandler_rescheduleTourByIrene = (
  postData: RescheduleTourByIreneWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RescheduleTourByIreneWebApiRequestDto, TourWebApiDto>(
    {
      endpoint: TourSchedulingWebApiHandler_rescheduleTourByIrene_Path,
      method: 'POST',
      contextPath: '/z-calendar',
      postData: postData,
    },
    client,
  );
};
